import mainSiteMixin from "@/mixins/mainSiteMixin";

export default {
    mixins: [mainSiteMixin],
    data() {
        return {
            loading: false,
            requireTwoFactor: false
        }
    },
    methods: {
        login(loginData) {
            if (this.requireTwoFactor) {
                this.challengeTwoFactor(loginData)
                return
            }
            this.$store.dispatch("booking/login", {loginData}).then(async (response) => {
                if (response.data?.two_factor) {
                    this.requireTwoFactor = true
                } else {
                    await this.$store.dispatch("booking/successfulLogin")
                }
                this.loading = false
            }).catch(error => {
                if (!error.response) {
                    console.log(error);
                } else if (error.response.status === 422) {
                    this.loading = false;
                }
            })
        },
        challengeTwoFactor(loginData) {
            let data = {}
            if (this.useRecoveryCodes) data.recovery_code = loginData.recovery_code
            else data.code = loginData.code
            this.$axios.post((this.$apiRoute('spa.two-factor.login')), {...data}
            ).then(async () => {
                await this.$store.dispatch("booking/successfulLogin")
                this.loading = false
            }).catch(error => {
                if (error.response.status === 429) {
                    this.$notify({type: 'warning', message: this.$i18n.t('bookings.twoFactor.tooManyAttempts')})
                    this.requireTwoFactor = false
                } else if (error.response.status === 422) {
                    this.$notify({type: 'warning', message: this.$i18n.t('bookings.twoFactor.wrongCode')})
                    this.$emit('authPageVisible', 'AuthLogin')
                }
                this.loading = false
            })
        }
    },
    computed: {
        isAuthenticated: {
            get() {
                return this.$store.state.booking.isAuthenticated
            }
        },
        userData: {
            get() {
                return this.$store.state.booking.userData
            }
        },
        abilities: {
            get() {
                return this.$store.state.booking.abilities
            }
        },
        canSelectContact() {
            return this.isAuthenticated && this.abilities.some(ability => ability.subject === 'contacts' && ability.action === 'write')
        }
    }
}
